/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-cycle */
import React, { useState, useEffect, useRef, SetStateAction } from 'react';
import ProcedureModal from './proceduremodal.component';
import { itemsprops } from './procedure.component';
import withScrollLock, { WithScrollLockProps } from '../../helper/withScrollLock';
import '../../helper/withScrollLock.css';

interface OptionMenuProps extends Omit<WithScrollLockProps, 'modalIsOpen' | 'setModalIsOpen'> {
  item: itemsprops;
  procedureChange: (updatedProcedure: any) => void;
  setProcedureSet: React.Dispatch<SetStateAction<itemsprops[]>>
  ProcedureSet:itemsprops[]
  index:number,
  serviceDetailIndex:number,
  admissionStartDate: string
  serviceType :string
}

const OptionMenu: React.FC<OptionMenuProps & WithScrollLockProps> = ({ item, procedureChange, setProcedureSet, ProcedureSet,
  index, serviceDetailIndex, admissionStartDate, serviceType, modalIsOpen, setModalIsOpen }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [procedureItem, setProcedureItem] = useState<itemsprops>(item);
  // const [modalIsOpen, setModalIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement | null>(null);
  const formData = {
    startDate: item.procedureStartDate !== '' ? new Date(item.procedureStartDate) : null,
    unitType: { label: item.unitType, value: item.unitType },
    unitFrequency: item.unitFrequency,
    modifier: item.modifier,
    modifier2: item.modifier2,
    NDCCode: item.NDCCode,
    drugName: item.drugName,
    doseQty: item.doseQty,
    doseQtyUnit: item.doseQtyUnit,
    route: { label: item.route, value: item.route },
    frequency: { label: item.frequency, value: item.frequency },
    adjustedDrugDosage: item.adjustedDrugDosage,
  };

  // eslint-disable-next-line max-len
  formData.unitType = serviceType.toLowerCase() === 'pharmacy' ? { label: 'HCPCS Units', value: 'HCPC Units' } : formData.unitType;

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const handleOutsideClick = (event: MouseEvent) => {
    if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
      setShowMenu(false);
    }
  };

  const handleEditProcedureClick = () => {
    setModalIsOpen(true);
  };

  useEffect(() => {
    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    const initialProcedureItemIndex = ProcedureSet.findIndex((i) => i.procedureCode === item.procedureCode);
    setProcedureSet((prev) => [...prev.slice(
      0,
      initialProcedureItemIndex,
    ), procedureItem, ...prev.slice(initialProcedureItemIndex + 1)]);
  }, [procedureItem]);

  return (
    <div ref={menuRef}>
      <div className="dropleft">
        <button
          type="button"
          aria-label="button"
          className="rounded-circle"
          style={{ borderColor: 'var(--bs-primary)', borderWidth: '2px' }}
          onClick={toggleMenu}
        >
          <i className="fas fa-ellipsis-h" style={{ color: 'var(--bs-primary)' }} />
        </button>
        <div
          className="dropdown-menu"
          aria-labelledby="dropdownMenuButton"
          style={{ display: showMenu ? 'block' : 'none',
            position: 'absolute',
            willChange: 'transform',
            transform: 'translate3d(-180px, -41px, 0px)' }}
          x-placement="left-start"
        >
          <div>
            <button
              type="button"
              className="dropdown-item"
              onClick={() => {
                handleEditProcedureClick();
                toggleMenu();
              }}
            >
              Edit Procedure Details
            </button>
          </div>
        </div>
      </div>
      {modalIsOpen && (
      <ProcedureModal
        onClose={() => setModalIsOpen(false)}
        item={procedureItem}
        formData={formData}
        setProcedureItem={setProcedureItem}
        index={index}
        serviceDetailIndex={serviceDetailIndex}
        admissionStartDate={admissionStartDate}
        serviceType={serviceType}
      />
      )}
    </div>
  );
};

export default withScrollLock(OptionMenu);
